import { Collapse, Divider, Form, Input, Empty, Switch, Popover } from "antd";

import { PM014ContentHandler } from "../handler/HandlerImpl";
import { useNavigate, useParams } from "react-router-dom";
import SubConstructionComponent from "./SubConstructionComponent";
import helpers from "../../../../../common/helpers/common";
import { useEffect, useMemo } from "react";
import { STATUS_APPROVE } from "../handler/Handler";
import COMMON, { PLAN_TYPE } from "../../../../../common/constants/COMMON";

// CSS
import "../../../../../assets/styles/PM/PM005.css";

// Icons
import EditBlue from "../../../../../assets/icons/edit-blue.svg";
import DeleteRed from "../../../../../assets/icons/delete-red.svg";
import IconDown from "../../../../../assets/icons/arrow.svg";
import BuildingSVG from "../../../../../assets/icons/building.svg";
import DocumentGraySVG from "../../../../../assets/icons/document-gray.svg";
import ChartIcon from "../../../../../assets/icons/chartPiePM005Icon.svg";
import {
  isHasPrivilege,
} from "../../../../../common/helpers/privilege";
import {
  PRIVILEGE_CREATOR,
  PRIVILEGE_PM,
} from "../../../../../common/constants/PRIVILEGE";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import {
  AUTHORIZATION_CODE,
} from "../../../../../common/constants/AUTHORIZATION";

const { Panel } = Collapse;

interface props {
  handler: PM014ContentHandler;
}
const MAX_LENGTH_NOTE = 300;

const ConstructionRegistrationComponent = ({ handler }: props) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const order = useSelector(
    (state: RootState) => state.auth?.authData?.order?.code
  );
  const isOrderBasic = order === PLAN_TYPE.PLAN_BASIC;
  useEffect(() => {
    if (handler.refNote && handler.refNote.current) {
      handler.refNote.current.focus();
    }
  }, [handler.refNote, handler.noteEdit, handler.noteView]);
  const authDataId = useSelector((state: RootState) => state.auth.authData?.id);
  const permission = useSelector(
    (state: RootState) => state.auth.authData?.permission
  );
  const isRoleAdmin = useSelector(
    (state: RootState) => state.auth?.authData?.isRoleAdmin
  );

  const isRoleAdminSystem = useSelector(
    (state: RootState) => state.auth?.authData?.isRoleAdminSystem
  );

  const subscription =
    useSelector(
      (state: RootState) => state.auth?.authData?.order?.subscription
    ) ?? [];

  const isProjectUserId =
    authDataId === handler.projectInfo?.projectManager?.id + "";

  const userIsPlanFree = useMemo(() => {
    const user = helpers.getObjectFromLocalStorage("user");
    return user.order.code === PLAN_TYPE.PLAN_FREE;
  }, []);

  const canExecutionBudgetList =
    ((permission?.includes(AUTHORIZATION_CODE.S0) &&
      permission?.includes(AUTHORIZATION_CODE.S18)) ||
      permission?.includes(AUTHORIZATION_CODE.B10) ||
      isRoleAdmin ||
      isRoleAdminSystem ||
      isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM])) &&
    !userIsPlanFree;

  const ButtonProjectBalance = (props: { subscription: any[] }) => {
    /* ticket pending */
    let isSubM17 = false;

    for (let element of props.subscription) {
      if (element.code === AUTHORIZATION_CODE.M17) isSubM17 = true;
    }
    return (isOrderBasic &&
      isSubM17 &&
      isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM])) ||
      permission?.includes(AUTHORIZATION_CODE.S42) ? (
      <div
        className="btn-redirect-cm001"
        onClick={() => handler.redirectToCM001()}
      >
        <span>案件収支</span> <img src={ChartIcon} alt="charticon" />
      </div>
    ) : null;
  };
  console.log(handler.projectInfo)
  return (
    <>
      <ButtonProjectBalance subscription={subscription} />

      <div className="build-register">工事一覧</div>

      <Form
        id="pm005form"
        form={handler.form}
        name="pm005form"
        onFinish={handler.onSaveConstruction}
      >
        <div className="build-register-container pm005-collapse-border">
          {handler.constructionUI?.main?.map(
            (element: {
              id: number;
              name: string;
              note: string;
              userId: number;
              contractValidation?: boolean;
              ciDocumentStatus: {
                name: string;
                code: string;
              };
              crDocumentStatus: {
                name: string;
                code: string;
              };
            }) => {
              const conditionButtonCI =
                ((permission?.includes(AUTHORIZATION_CODE.S0) &&
                  permission?.includes(AUTHORIZATION_CODE.S14)) ||
                  permission?.includes(AUTHORIZATION_CODE.B10) ||
                  isProjectUserId ||
                  isRoleAdmin ||
                  isRoleAdminSystem ||
                  isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM]) ||
                  handler.approverCIMapper[`${element?.id}`]) &&
                isOrderBasic;

              const conditionButtonCR =
                ((permission?.includes(AUTHORIZATION_CODE.S0) &&
                  permission?.includes(AUTHORIZATION_CODE.S18)) ||
                  permission?.includes(AUTHORIZATION_CODE.B10) ||
                  isProjectUserId ||
                  handler.approverCRMapper[`${element?.id}`] ||
                  isRoleAdmin ||
                  isRoleAdminSystem ||
                  isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM])) &&
                isOrderBasic;

              const canEditContractValidation =
                (isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM]) ||
                  isRoleAdmin ||
                  isRoleAdminSystem) && handler.projectInfo?.status?.id !== 6;

              const notShowCollapse = !conditionButtonCR && !conditionButtonCI;

              const noteEditContent = (
                <div style={{ minWidth: 250, maxWidth: 350 }}>
                  <Form.Item
                    name={`main${element?.id}`}
                    className="pm005-input-note"
                  >
                    <Input.TextArea
                      placeholder="メモを入力してください。"
                      autoSize
                      maxLength={MAX_LENGTH_NOTE}
                      onChange={(e: any) =>
                        handler.handleChangeInputArea(
                          e,
                          `main${element?.id}`
                        )
                      }
                      onMouseDown={(e) => e.stopPropagation()}
                      ref={handler.refNote}
                    />
                  </Form.Item>

                  <Divider className="pm005-note-divider" />

                  <div className="pm005-note-save">
                    <span
                      className="pm005-note-save-text"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        handler.handleSaveUpdateNote(
                          element?.id,
                          `main${element?.id}`
                        );

                        handler.setNoteEdit(0);
                        handler.handleChangeNoteView(0);
                      }}
                    >
                      保存
                    </span>

                    <span
                      className="pm005-note-cancel-text"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        handler.handleCancelUpdateNote();
                        handler.setNoteEdit(0);
                        handler.handleChangeNoteView(0);
                      }}
                    >
                      キャンセル
                    </span>
                  </div>
                </div>
              );
              const noteViewContent = (
                <div style={{ minWidth: 250, maxWidth: 350 }}>
                  {element?.note ? (
                    <span
                      className="pm005-note-text"
                      style={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all',
                      }}
                    >
                      {element.note}
                    </span>
                  ) : (
                    <Form.Item
                      name={`view_main${element?.id}`}
                      className="pm005-input-note"
                    >
                      <Input.TextArea
                        disabled={true}
                        placeholder="メモを入力してください。"
                        autoSize
                      />
                    </Form.Item>
                  )}

                  {helpers.checkRoleUpdate(
                    element?.userId,
                    handler.projectInfo?.projectManager?.id
                  ) && (
                      <>
                        <Divider className="pm005-note-divider" />
                        <div className="pm005-note-btn">
                          <div
                            className="pm005-note-edit"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();

                              handler.handleChangeNoteView(0);
                              handler.setNoteEdit(element?.id);
                            }}
                          >
                            <img
                              src={EditBlue}
                              alt=""
                              className="pm005-note-icon-edit"
                            />
                            <span>編集</span>
                          </div>

                          {element?.note !== '' && (
                            <div
                              className="pm005-note-delete"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handler.handleDeleteNoteConstruction(
                                  element?.id
                                );
                              }}
                            >
                              <img
                                src={DeleteRed}
                                alt=""
                                className="pm005-note-icon-delete"
                              />
                              <span>削除</span>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                </div>
              );

              return (
                <Collapse
                  key={element.id}
                  className="folder-collapse collapse-main"
                  collapsible={notShowCollapse ? "disabled" : undefined}
                  activeKey={
                    notShowCollapse ? undefined : handler.keyCollapseMain
                  }
                  onChange={
                    notShowCollapse
                      ? undefined
                      : handler.handleChangeCollapseMain
                  }
                  expandIcon={({ isActive }) => {
                    if (notShowCollapse) return <></>;
                    return (
                      <div
                        className={`${isActive ? "collapse-icon-active" : ""
                          } collapse-icon`}
                      >
                        <img src={IconDown} alt="" />
                      </div>
                    );
                  }}
                >
                  <Panel
                    collapsible={
                      !(handler.noteEdit === element?.id)
                        ? undefined
                        : "disabled"
                    }
                    key={`main${element?.id}`}
                    header={
                      <div className="panel-construction-wrapper">
                        <div
                          className="tag-wrapper"
                        >
                          <div className="tag-contaner">
                            <img src={BuildingSVG} alt="" />
                            <span style={{ marginLeft: 12 }}>
                              {handler.projectInfo?.parentConstruction?.name ||
                                ""}
                            </span>
                            <div>{element?.name}</div>

                            <Popover
                              overlayClassName="pm005-note-popover"
                              content={noteViewContent}
                              trigger="hover"
                              visible={
                                handler.noteEdit === 0 &&
                                handler.noteView === element?.id &&
                                element?.id !== 0
                              }
                              onVisibleChange={(visible) => {
                                if (handler.noteEdit !== 0) return;

                                if (visible) {
                                  handler.handleChangeNoteView(element?.id);
                                } else {
                                  handler.handleChangeNoteView(0);
                                }
                              }}
                              placement="rightTop"
                              getPopupContainer={(trigger) =>
                                trigger.parentNode as HTMLElement
                              }
                            >
                              <div
                                className="pm005-note"
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                <img src={DocumentGraySVG} alt="" />
                              </div>
                            </Popover>

                            <Popover
                              overlayClassName="pm005-note-popover-edit"
                              content={noteEditContent}
                              trigger="click"
                              visible={handler.noteEdit === element?.id}
                              placement="rightTop"
                              getPopupContainer={(trigger) =>
                                trigger.parentNode as HTMLElement
                              }
                              onVisibleChange={(visible) => {
                                if (!visible) {
                                  handler.setNoteEdit(0);
                                  handler.handleChangeNoteView(0);
                                }
                              }}
                            >
                              <span />
                            </Popover>
                          </div>

                        </div>
                        {isOrderBasic && (
                          <div className="pm005-contract-validation-wrapper">
                            <span>工事契約状況</span>
                            <div
                              className="pm005-contract-validation-wrapper-switch-wrapper"
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor:
                                  (element?.contractValidation ?? false)
                                    ? "#0FA44A26"
                                    : "#FF383C26",
                              }}
                            >
                              <span
                                style={{
                                  color: (element?.contractValidation ?? false)
                                    ? "#0FA44A"
                                    : "#FF383C",
                                }}
                              >
                                {(element?.contractValidation ?? false)
                                  ? "契約済み"
                                  : "未契約"}
                              </span>
                              <Switch
                                className="pm005-contract-validation-switch"
                                checked={
                                  element?.contractValidation ?? false
                                }
                                disabled={!canEditContractValidation}
                                onChange={(checked) => {
                                  handler.updateContractValidation({
                                    constructionId: element.id,
                                    contractValidation: checked,
                                  });
                                }}
                              />

                            </div>
                          </div>
                        )}
                      </div>
                    }
                  >
                    <div className="tag-contaner-white">
                      {conditionButtonCI ? (
                        <div
                          style={{ cursor: "pointer" }}
                          className="tag-white-container pm005-btn-view"
                          onClick={() =>
                            handler.onViewConstructionInquiry(
                              element?.id,
                              projectId || ""
                            )
                          }
                        >
                          <span>工事引合書</span>
                          <div
                            className="pm005-status-approve"
                            style={{
                              color:
                                STATUS_APPROVE[
                                  element.ciDocumentStatus?.code || "reject"
                                ].color,
                              backgroundColor:
                                STATUS_APPROVE[
                                  element.ciDocumentStatus?.code || "reject"
                                ].background_color,
                            }}
                          >
                            {element.ciDocumentStatus?.name}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {conditionButtonCR ? (
                        <div
                          style={{
                            cursor: conditionButtonCR
                              ? "pointer"
                              : "not-allowed",
                          }}
                          className="tag-white-container pm005-btn-view"
                          onClick={() =>
                            conditionButtonCR &&
                            handler.onViewRunningBudget(
                              element?.id,
                              projectId || ""
                            )
                          }
                        >
                          <span>実行予算書</span>
                          <div
                            className="pm005-status-approve"
                            style={{
                              color:
                                STATUS_APPROVE[
                                  element.crDocumentStatus?.code || "reject"
                                ].color,
                              backgroundColor:
                                STATUS_APPROVE[
                                  element.crDocumentStatus?.code || "reject"
                                ].background_color,
                            }}
                          >
                            {element.crDocumentStatus?.name}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Panel>
                </Collapse>
              );
            }
          )}
          <SubConstructionComponent handler={handler} />
          {canExecutionBudgetList ? (
            <div
              className="tag-contaner pm005-document-view"
              style={{
                cursor: "pointer",
                paddingLeft: 40,
                height: 56
              }}
              onClick={() => {
                navigate(`/app-crt001/${projectId}`);
                localStorage.setItem(
                  COMMON.PARENT_CONSTRUCTION,
                  handler.projectInfo?.parentConstruction?.name
                );
              }}
            >
              <img src={DocumentGraySVG} alt="" />
              <div
                style={{
                  marginLeft: 16,
                }}
              >
                実行予算一覧
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Form>
    </>
  );
};

export default ConstructionRegistrationComponent;